// extracted by mini-css-extract-plugin
export default {"contacts__wrapper":"Contacts_contacts__wrapper__O1kIe","contacts__cards":"Contacts_contacts__cards__F3AJR","contacts__cards_p":"Contacts_contacts__cards_p__10bqQ"};